/**
 * @generated SignedSource<<855999b5ee44538857a836cbda300488>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersCheckCanShowInPlusPlatformArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckArticleIsInSectionsArticle" | "helpersCheckIsPlusArticle" | "helpersCheckIsStyleArticle" | "helpersGetArticleTypeArticle" | "helpersUseContentSponsorContent">;
  readonly " $fragmentType": "helpersCheckCanShowInPlusPlatformArticle";
};
export type helpersCheckCanShowInPlusPlatformArticle$key = {
  readonly " $data"?: helpersCheckCanShowInPlusPlatformArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckCanShowInPlusPlatformArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersCheckCanShowInPlusPlatformArticle"
};

(node as any).hash = "a510a582704347c879336b002285cf96";

export default node;
